import BannerSlide from './BannerSlide';

export default BannerSlide;
